import { fetchDefectReportV1ControllerGetListByRings } from 'generated/apiComponents';
import { defectReportSyncService } from 'technical/db/sync/defect-report-sync.service';

const PAGE_SIZE = 5;

export const syncDefectReportData = async (
  constructionSiteId: string,
  ringNumberStart: number,
  ringNumberEnd: number,
  headers: any,
) => {
  let page = 0;
  let hasMore = true;

  while (hasMore) {
    const response = await fetchDefectReportV1ControllerGetListByRings({
      pathParams: { constructionSiteId },
      queryParams: {
        ringNumberStart,
        ringNumberEnd,
        paginationPage: page,
        paginationSize: PAGE_SIZE,
      },
      headers,
    });

    const defects = response?.defectReports ?? [];
    if (defects.length > 0) {
      await defectReportSyncService.download(defects);
    }

    if (defects.length < PAGE_SIZE) {
      hasMore = false;
    } else {
      page++;
    }
  }
};
